import { apiClient } from "@base/api/client";
import type { PaymentStatus } from "../model/types";

export type ApplyMembershipPaymentPayload = {
  company: {
    title: string;
    representative_first_name: string;
    representative_last_name: string;
    phone_number: string;
    phone_number_country_code: number;
    email: string;
  };
  membership: {
    type: string;
    billing_cycle: string;
  };
};

export const postApplyMembershipPayment = async (
  data: ApplyMembershipPaymentPayload,
): Promise<{ hosted_page: string; payment_id: string }> => {
  const response = await apiClient.post("/82office/payment/api/membership", data);
  return response.data;
};

export const fetchPaymentStatus = async (paymentId: string): Promise<{ status: PaymentStatus }> => {
  const response = await apiClient.get(`/82office/payment/api/result?payment_id=${paymentId}`);
  return response.data;
};
